import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {EventsService} from "../../../events.service";

@Component({
  selector: 'app-ramadan2022-tournament',
  templateUrl: './ramadan2022-tournament.component.html',
  styleUrls: ['./ramadan2022-tournament.component.scss']
})
export class Ramadan2022TournamentComponent implements OnInit {
  activeGame = 'valorant';
  games;
  tournaments;
  events
  constructor(private router:Router , private activatedRoute:ActivatedRoute , public eventService:EventsService) {

  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(param => {
      if(param){
        this.activeGame = param.game
      }
    })
    this.setActiveGame(this.activeGame )
  }
  getEventTournament(){
    this.eventService.loadEventTournaments = true;

    this.eventService.getEventTournaments('ramadan-2022', 1, this.activeGame).subscribe(res => {
      this.tournaments = res.data
      // this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })

  }
  setActiveGame(code) {
    // console.log(code)
    this.activeGame = code;
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: {game: code},
        queryParamsHandling: 'merge'
      });
    this.getEventTournament()
  }


  }
